<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Forgot Password v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <!-- logo -->
           <b-img
            fluid
            :src="imgUrl"
            alt="logo"
            width="100"
          />
        </b-link>

        <b-card-title class="mb-1">
          Lupa Sandi? 🔒
        </b-card-title>
        <b-card-text class="mb-2">
          Masukkan alamat email Anda dan kami akan mengirimkan instruksi untuk me-reset password Anda.
        </b-card-text>

        <!-- form -->
        <validation-observer ref="simpleRules">
          <b-form
            class="auth-forgot-password-form mt-2"
            @submit.prevent="validationForm"
          >
            <!-- email -->
            <b-form-group
              label="Email"
              label-for="forgot-password-email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="forgot-password-email"
                  v-model="userEmail"
                  :state="errors.length > 0 ? false:null"
                  name="forgot-password-email"
                  placeholder="ujian@online.com"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              block
              type="submit"
            >
              Kirim link atur ulang password
            </b-button>
          </b-form>
        </validation-observer>
        <br>
        <center v-if="loading == 1"><b-spinner label="Spinning"></b-spinner></center>

        <b-card-text class="text-center mt-2">
          <b-link :to="{name:'auth-login'}">
            <feather-icon icon="ChevronLeftIcon" /> Kembali ke halaman login
          </b-link>
        </b-card-text>

      </b-card>
    <!-- /Forgot Password v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BCard, BLink, BCardText, BCardTitle, BFormGroup, BFormInput, BForm, BButton,BImg, BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import store from '@/store/index'
import {
  postLupaPassword,
} from '@/connection-api/master'

export default {
  components: {
    VuexyLogo,
    BCard,
    BLink,
    BCardText,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BButton,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BImg,
    BSpinner,
  },
  data() {
    return {
      loading: 0,
      userEmail: null,
      // validation
      required,
      email,
      sideImg: require('@/assets/images/logo/logo.png'),
    }
  },
  methods: {
    validationForm() {
      this.loading = 1
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          var data = {
            email: this.userEmail
          }
            postLupaPassword(data)
            .then(response => {
              if (response.data.success === true) {
                this.loading = 0
                this.makeToast('success', 'Link reset password telah dikirimkan ke email anda')
                setTimeout(() => {
                  this.$router.push({ name: 'auth-login'})
                }, 3000);
              } else {
                this.loading = 0
                this.makeToast('danger', response.data.message)
              }
            })
            .catch(error => console.log(error));
        }
      })
    },
     makeToast(variant = null, message = null, title = null) {
      this.$bvToast.toast(message, {
        title: 'Forgot Password',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
  },
  computed: {
     imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/logo/logo.png')
        return this.sideImg
      }
      return this.sideImg
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
